import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { Header, Progress } from './styles';

const ViewCompleted = () => {
    const { t } = useTranslation();

    return (
        <>
            <Header>
                <Typography variant="h6">{t('OnboardingPage.success')} 🎉 🎉 🎉</Typography>
                <Typography variant="body2" sx={{ color: 'var(--text-secondary)', marginTop: '4px' }}></Typography>
            </Header>
            <div style={{ gridArea: 'main', padding: '24px' }}>
                <Progress />
            </div>
        </>
    );
};

export default ViewCompleted;
